import { Icon, Select, useEffect, useState, Toast, useForm, Controller, showAddUpdateConfirm, CustomModal, useUser, } from '../../utils/commonImports';
import { Alert, Spin, Upload, Divider, Button, Tag } from "antd";
import { UploadOutlined, FilePdfOutlined } from "@ant-design/icons";
import axios from "axios";
import { customStyleMd } from "../../utils/common";
import { _api, apiUrl } from '../../auth/Api';
import { getPageRights } from '../../utils/accessPages';

const VehicleManual = () => {
    const { handleSubmit, control, setValue, reset, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState({ isOpen: false, data: {} });
    const [vehicleOptions, setVehicleOptions] = useState([]);
    const [manualList, setManualList] = useState([]);
    const [file, setFile] = useState(null);
    const [fileList, setFileList] = useState([]);

    const { loggedInUser } = useUser();
    const userPages = loggedInUser?.roles?.[0]?.pages || [];
    const rights = getPageRights(userPages, 9);

    useEffect(() => {
        _getVehicles();
    }, []);

    const _getVehicles = async () => {
        try {
            await _api("GET", "Vehicle/GetDistinctVehicles", null, (res) => {
                if (res.isSuccess) {
                    // const uniqueVehicles = res.data.filter(
                    //     (v, index, self) =>
                    //       index === self.findIndex((t) => t.itemName === v.itemName)
                    //   );
                    const List = res.data.map((v) => ({
                        value: v.id,
                        label: v.itemName,
                    }));
                    setVehicleOptions(List);
                    setManualList(res.data)
                }
            });
        } catch (error) {
            console.log("API Error", error?.message);
        }
    };

    const handleSave = async (data) => {
        if (!file) {
            Toast.fire({ icon: 'warning', title: 'Please upload a PDF file' })
            return;
        }
        const isSure = await showAddUpdateConfirm(`Are you sure! you want to add this user guide manual?`)
        if (isSure) {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append("vehicleId", data.vehicle?.value);
                formData.append("file", file);
                const storedToken = localStorage.getItem("x_t");
                const token = storedToken ? JSON.parse(storedToken).t : null;
                const res = await axios.post(`${apiUrl}Vehicle/UpdateForManual`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (res?.data?.isSuccess) {
                    Toast.fire({ icon: 'success', title: res?.data?.message })
                    _getVehicles();
                    reset(); 
                    setFile(null);
                    setValue("vehicle", null); 

                    setFileList([]);
                } else {
                    Toast.fire({ icon: 'error', title: res?.data?.message })
                }
            } catch (error) {
                Toast.fire({ icon: 'error', title: 'Failed to update User Manual' })
                console.error('Error saving menu:', error);
            } finally {
                setLoading(false);
            }
        }

    };

    const uploadProps = {
        beforeUpload: (file) => {
            setFile(file);
            setFileList([file]); 
            return false;
        },
        onRemove: () => {
            setFile(null);
            setFileList([]);
        },
        accept: "application/pdf",
        fileList
    };

    return (
        <div className="container mt-4">
            <Alert
                type="info"
                showIcon
                closable
                className="mb-3"
                description="Upload PDF manuals for selected vehicles. These manuals will be available for users in the app."
            />

            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(handleSave)}>
                    <div className="row">

                        <div className="col-md-4 mb-0">
                            <div className="form-group input-group-md">
                                <label className="small">Select Vehicle</label>
                                <Controller
                                    name="vehicle"
                                    control={control}
                                    rules={{ required: "Vehicle is required" }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            value={field.value}
                                            options={vehicleOptions}
                                            placeholder="Select Vehicle"
                                            styles={customStyleMd} />
                                    )}
                                />
                                {errors.vehicle && <small className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.vehicle.message}</small>}
                            </div>
                        </div>

                        <div className="col-md-4 mb-0">
                            <label className="small">Upload PDF</label>
                            <Upload {...uploadProps} maxCount={1}>
                                <button type="button"
                                    style={{
                                        height: '43px', border: '1px solid #d1d5db', width: '100%', textAlign: 'left', transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                                        fontSize: "14px", fontWeight: 400, backgroundColor: '#fff', color: '#495057', borderRadius: '0.375rem', padding: "0px 12px",
                                    }} >
                                    <UploadOutlined style={{ marginRight: 6 }} /> Upload
                                </button>
                            </Upload>
                            {/* {file && <div className="mt-1 small text-success">{file.name}</div>} */}
                        </div>

                        <Divider orientation="right" plain orientationMargin={0}>
                            {rights && rights.add && (
                                <div className="row">
                                    <div className="d-flex justify-content-end gap-2">
                                        <button type="submit" style={{ lineHeight: '1.2' }}
                                            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm"
                                        >
                                            Save
                                            <Icon icon="mdi:plus-circle-outline" className="text-md" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </Divider>
                    </div>
                </form>

                {/* Manuals List */}
                <div className="row g-3">
                    {manualList.length > 0 ? (
                        manualList.map(item => (
                            <div className="col-md-3" key={item.id}>
                                <div className="d-flex p-3 bg-white border rounded h-100">
                                    <div className="me-3 d-flex align-items-center justify-content-center bg-light rounded w-25" style={{ width: 60, height: 60 }}>
                                        <FilePdfOutlined style={{ fontSize: 30, color: "#10477fe3" }} />
                                    </div>
                                    <div className="d-flex flex-column justify-content-left w-75">
                                        <div title={item.itemName}>
                                            <Tag color="blue" style={{ fontSize: 11, display: "inline-block", maxWidth: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }} >
                                                {item.itemName}
                                            </Tag>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <Button size="small" onClick={() => setIsModalOpen({ isOpen: true, data: item })}> View </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-muted">No manuals found</div>
                    )}
                </div>
            </Spin>

            <CustomModal show={isModalOpen.isOpen} size="lg" onHide={() => setIsModalOpen({ isOpen: false, data: {} })} title="User Manual">
                <div style={{ position: "relative", minHeight: "200px" }}>
                    {isLoading && (
                        <div className="d-flex justify-content-center align-items-center"
                            style={{ position: "absolute", inset: 0, zIndex: 10, backgroundColor: "rgba(255, 255, 255, 0.7)" }}
                        >
                            <div class="spinner-border custom-spinner" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {isModalOpen.isOpen && (() => {
                        const ext = isModalOpen?.data?.itemPdfUrl?.split(".").pop()?.toLowerCase();
                        if (ext === "pdf") {
                            return (
                                <iframe
                                    src={isModalOpen?.data?.itemPdfUrl}
                                    title="PDF Document"
                                    style={{ width: "100%", height: "500px", border: "none", display: isLoading ? "none" : "block" }}
                                    onLoad={() => setIsLoading(false)}
                                />
                            );
                        } else {
                            return <p>Unsupported file type</p>;
                        }
                    })()}

                </div>
            </CustomModal>

        </div>
    );
};

export default VehicleManual;